import Cookies from 'js-cookie';
import router from '@router/index'
import redirectTo from '@/src/utils/redirectTo';

export default{

    userSuccess: (state, resp) => {
        state.user = resp;
       Cookies.set('user', JSON.stringify(resp), { expires: 365 });
        localStorage.setItem('user', JSON.stringify(resp));
       redirectTo(state.user)
       // Vue.set(state, 'data', resp);
        //Vue.set(state, 'profile', resp);


  },

  setUserFlags: (state, flags) => {
    state.userFlags = flags;
  },

userLogout: (state) => {
    state.user = null;
    Cookies.remove('user');
    localStorage.removeItem('user');
    router.push('/login');

}

}